export const GENERAL_PARTNERSHIP = "GENERAL_PARTNERSHIP";
export const LIMITED_LIABILITY_PARTNERSHIP = "LIMITED_LIABILITY_PARTNERSHIP";
export const LIMITED_PARTNERSHIP = "LIMITED_PARTNERSHIP";

export const partnershipTypesDisplay = {
  [GENERAL_PARTNERSHIP]: "General Partnership",
  [LIMITED_LIABILITY_PARTNERSHIP]: "Limited Liability Partnership",
  [LIMITED_PARTNERSHIP]: "Limited Partnership",
};
